<template>
  <header class="app-header" :class="[
      {'app-header--active': showMobileMenu},
      `app-header--${finalHeaderTheme}`,
      {'app-header--scrolled': isScrolled || isFixedHeaderPage}
    ]">
    <!-- Logo部分（PC和Mobile共用） -->
    <a class="app-header__logo" :href="homePath">
      <img :src="domainConfig?.['siteIcon']" class="app-header__logo-icon" alt="">
      <div class="app-header__logo-text">
        {{domainConfig?.['siteName']}}
      </div>
    </a>

    <!-- PC导航菜单 (只在桌面设备显示) -->
    <nav class="app-header__nav" v-if="deviceType === 'desktop' || deviceType === 'pc'">
      <a class="app-header__nav-item" :class="{'app-header__nav-item--active': isRouteActive('/')}"
        :href="homePath">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
          fill="none">
          <path
            d="M11.5115 9.56458C11.0921 9.50554 10.6728 9.44649 10.1935 9.44649C8.69584 9.44649 7.25806 9.85978 6 10.6863C4.74194 9.91882 3.30416 9.44649 1.80647 9.44649C1.38712 9.44649 0.907855 9.50554 0.488502 9.56458C0.188964 9.62362 -0.0506662 9.91882 0.00924142 10.2731C0.069149 10.6273 0.368687 10.8044 0.728133 10.7454C1.08758 10.6863 1.44702 10.6273 1.80647 10.6273C3.18434 10.6273 4.50231 11.0406 5.64055 11.8672C5.82028 12.0443 6.11982 12.0443 6.35945 11.8672C7.79723 10.8635 9.59446 10.4502 11.2719 10.7454C11.5714 10.8044 11.9309 10.5683 11.9908 10.2731C12.0507 9.91882 11.811 9.62362 11.5115 9.56458ZM11.5115 0.118081C11.0921 0.0590406 10.6728 0 10.1935 0C8.69584 0 7.25806 0.413284 6 1.23985C4.74194 0.413284 3.30416 0 1.80647 0C1.38712 0 0.907855 0.0590406 0.488502 0.118081C0.248872 0.118081 0.00924142 0.413284 0.00924142 0.649447V7.73432C0.00924142 8.08856 0.248872 8.32472 0.608317 8.32472H0.728133C1.08758 8.26568 1.44702 8.20664 1.80647 8.20664C3.18434 8.20664 4.50231 8.61993 5.64055 9.44649C5.82028 9.62362 6.11982 9.62362 6.35945 9.44649C7.79723 8.4428 9.59446 8.02952 11.2719 8.32472C11.5714 8.38376 11.9309 8.1476 11.9908 7.8524C11.9908 7.79336 11.9908 7.79336 11.9908 7.73432V0.649447C11.9908 0.413284 11.7511 0.118081 11.5115 0.118081Z"
            fill="black" />
        </svg>
        Home
      </a>
      <!-- -->
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/all')}"
        @mouseover="showCategoriesDropdown = true" @mouseleave="showCategoriesDropdown = false">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
          fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M1.6 0C0.716344 0 0 0.716344 0 1.6V4C0 4.88366 0.716344 5.6 1.6 5.6H4C4.88366 5.6 5.6 4.88366 5.6 4V1.6C5.6 0.716344 4.88366 0 4 0H1.6Z"
            fill="black" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M9.59004 0.311308C9.54864 0.129214 9.38674 0 9.2 0C9.01326 0 8.85136 0.129214 8.80996 0.311308L8.58864 1.28459C8.48628 1.73476 8.13476 2.08628 7.68458 2.18864L6.7113 2.40996C6.52922 2.45136 6.4 2.61326 6.4 2.8C6.4 2.98674 6.52922 3.14864 6.7113 3.19004L7.68458 3.41136C8.13476 3.51372 8.48628 3.86524 8.58864 4.31542L8.80996 5.2887C8.85136 5.47078 9.01326 5.6 9.2 5.6C9.38674 5.6 9.54864 5.47078 9.59004 5.2887L9.81136 4.31542C9.91372 3.86524 10.2652 3.51372 10.7154 3.41136L11.6887 3.19004C11.8708 3.14864 12 2.98674 12 2.8C12 2.61326 11.8708 2.45136 11.6887 2.40996L10.7154 2.18864C10.2652 2.08628 9.91372 1.73476 9.81136 1.28459L9.59004 0.311308Z"
            fill="black" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0 8C0 7.11634 0.716344 6.4 1.6 6.4H4C4.88366 6.4 5.6 7.11634 5.6 8V10.4C5.6 11.2837 4.88366 12 4 12H1.6C0.716344 12 0 11.2837 0 10.4V8Z"
            fill="black" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8 6.4C7.11634 6.4 6.4 7.11634 6.4 8V10.4C6.4 11.2837 7.11634 12 8 12H10.4C11.2837 12 12 11.2837 12 10.4V8C12 7.11634 11.2837 6.4 10.4 6.4H8Z"
            fill="black" />
        </svg>
        Categories

        <svg class="app-header__nav-arrow"
          :class="{'app-header__nav-arrow--flip': showCategoriesDropdown}"
          xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
          <path
            d="M4.00051 2.79018L0.974418 0.146758C0.750414 -0.0489193 0.392007 -0.0489193 0.168003 0.146758C-0.056001 0.342435 -0.056001 0.655519 0.168003 0.851196L3.51585 3.77568C3.53621 3.80414 3.56065 3.82905 3.58916 3.85395C3.70319 3.95357 3.84982 4.00338 4.00051 3.99982C4.14713 3.99982 4.29782 3.95357 4.41186 3.85395C4.44037 3.82905 4.46481 3.80414 4.48517 3.77568L7.83302 0.851196C7.94298 0.755136 8 0.627057 8 0.498977C8 0.370897 7.94298 0.242818 7.83302 0.146758C7.60901 -0.0489193 7.25061 -0.0489193 7.0266 0.146758L4.00051 2.79018Z"
            fill="white" />
        </svg>

        <!-- Categories下拉菜单 -->
        <div class="app-header__dropdown" v-if="showCategoriesDropdown">
          <div class="app-header__dropdown-content">
            <div class="app-header__dropdown-items">
              <a class="app-header__dropdown-item" v-for="category in categories"
                :key="category.value" :href="getCategoryPath(category.value)">
                <div class="app-header__dropdown-item-icon-container">
                  <img :src="category.originalIcon" alt="" class="app-header__dropdown-item-icon">
                </div>
                <div class="app-header__dropdown-item-text">{{ category.name }}</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <a class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/rank')}"
        :href="`${channelPrefix}/rank`">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
          fill="none">
          <path
            d="M6 0C5.80302 0 5.63472 0.0961647 5.5078 0.213572C5.38088 0.33098 5.27903 0.47454 5.18487 0.635508C4.99654 0.957443 4.83682 1.3563 4.68095 1.76327C4.52508 2.17024 4.37566 2.58362 4.23302 2.91318C4.09037 3.24274 3.92546 3.48566 3.88535 3.51613C3.84523 3.54659 3.57302 3.63634 3.22908 3.67631C2.88513 3.71627 2.4613 3.73567 2.04284 3.76486C1.62438 3.79405 1.21293 3.8321 0.861812 3.91983C0.686252 3.9637 0.523469 4.01877 0.377421 4.10866C0.231373 4.19855 0.091925 4.33478 0.0310553 4.5306C-0.0298147 4.72641 0.00641869 4.92552 0.0740254 5.08797C0.141632 5.25042 0.241827 5.3939 0.359191 5.53725C0.593919 5.82395 0.905579 6.10823 1.22771 6.38893C1.54984 6.66964 1.88211 6.94619 2.1379 7.18983C2.39368 7.43347 2.56269 7.67186 2.57801 7.72116C2.59334 7.77045 2.59064 8.06882 2.52072 8.42308C2.4508 8.77734 2.33831 9.20397 2.23555 9.62898C2.1328 10.054 2.03896 10.4744 2.01029 10.8505C1.99595 11.0386 1.99576 11.2167 2.03242 11.3897C2.06908 11.5626 2.15172 11.7453 2.31108 11.8663C2.47044 11.9873 2.66192 12.0122 2.83063 11.9952C2.99933 11.9782 3.16004 11.9243 3.32674 11.852C3.66013 11.7072 4.01478 11.4825 4.36974 11.249C4.7247 11.0155 5.07816 10.7729 5.37889 10.594C5.67962 10.415 5.95042 10.3205 6 10.3205C6.04958 10.3205 6.32039 10.415 6.62112 10.594C6.92184 10.7729 7.27531 11.0155 7.63026 11.249C7.98522 11.4825 8.33987 11.7072 8.67327 11.852C8.83997 11.9243 9.00067 11.9782 9.16938 11.9952C9.33808 12.0122 9.52957 11.9873 9.68892 11.8663C9.84828 11.7453 9.93092 11.5626 9.96758 11.3897C10.0042 11.2167 10.0041 11.0386 9.98971 10.8505C9.96103 10.4744 9.8672 10.054 9.76445 9.62898C9.66169 9.20397 9.5492 8.77734 9.47928 8.42308C9.40936 8.06882 9.40666 7.77045 9.42199 7.72116C9.43731 7.67186 9.60632 7.43347 9.86211 7.18983C10.1179 6.94619 10.4502 6.66964 10.7723 6.38893C11.0944 6.10823 11.4061 5.82395 11.6408 5.53725C11.7582 5.3939 11.8584 5.25042 11.926 5.08797C11.9936 4.92552 12.0298 4.72641 11.9689 4.5306C11.9081 4.33478 11.7686 4.19855 11.6226 4.10866C11.4765 4.01877 11.3138 3.9637 11.1382 3.91983C10.7871 3.8321 10.3756 3.79405 9.95716 3.76486C9.5387 3.73567 9.11487 3.71627 8.77092 3.67631C8.42698 3.63634 8.15477 3.54659 8.11465 3.51613C8.07454 3.48566 7.90963 3.24274 7.76699 2.91318C7.62434 2.58362 7.47492 2.17024 7.31906 1.76327C7.16319 1.3563 7.00346 0.957443 6.81513 0.635508C6.72097 0.47454 6.61913 0.33098 6.4922 0.213572C6.36528 0.0961647 6.19698 -6.66666e-08 6 0Z"
            fill="black" />
        </svg>
        Rankings
      </a>

      <!-- <div class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/resources')}"
        @click="$router.push('/resources')">
        Resources
      </div> -->
    </nav>

    <!-- Mobile菜单按钮 (只在移动设备显示) -->
    <div class="app-header__mobile-trigger" v-if="deviceType === 'mobile'"
      @click="toggleMobileMenu">
      <div class="app-header__mobile-menu-btn">
        <span>Menu</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none"
          :style="{transform: showMobileMenu ? 'rotate(180deg)' : 'none'}">
          <path d="M1 1L4 4L7 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
    </div>

    <!-- Mobile菜单 (显示/隐藏取决于showMobileMenu) -->
    <div class="app-header__mobile-menu" v-if="showMobileMenu && (deviceType === 'mobile')">
      <div class="app-header__mobile-menu-header">
        <a class="app-header__logo" :href="homePath">
          <img :src="domainConfig?.['siteIcon']" class="app-header__logo-icon" alt="">
          <div class="app-header__logo-text">
            {{domainConfig?.['siteName']}}
          </div>
        </a>
        <!-- <div class="app-header__mobile-trigger" @click="toggleMobileMenu">
          <img src="@/assets/clos-menu.svg" alt="Close menu">
        </div> -->
        <div class="app-header__mobile-trigger" v-if="deviceType === 'mobile'"
          @click="toggleMobileMenu">
          <div class="app-header__mobile-menu-btn">
            <span>Menu</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"
              fill="none" :style="{transform: showMobileMenu ? 'rotate(180deg)' : 'none'}">
              <path
                d="M1.22595 4.77791L4.00359 1.8318L6.78121 4.77791C7.06041 5.07403 7.51141 5.07403 7.79061 4.77791C8.0698 4.48178 8.0698 4.00339 7.79061 3.70727L4.50471 0.222094C4.22551 -0.0740314 3.77451 -0.0740314 3.49531 0.222094L0.209395 3.70727C-0.0697985 4.00339 -0.0697985 4.48178 0.209395 4.77791C0.488589 5.06644 0.946754 5.07403 1.22595 4.77791Z"
                fill="black" />
            </svg>
          </div>
        </div>
      </div>

      <div class="app-header__mobile-menu-content">
        <!-- Categories Section -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-section-title">Categories</div>
          <div class="app-header__mobile-menu-links">
            <a class="app-header__mobile-menu-link" v-for="category in categories"
              :key="category.value" :href="getCategoryPath(category.value)">
              <div class="app-header__mobile-menu-link-icon-container">
                <img :src="category.originalIcon" alt="" class="app-header__mobile-menu-link-icon">
              </div>
              <div class="app-header__mobile-menu-link-text">{{ category.name }}</div>
            </a>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Rankings Section -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-section-title">Rankings</div>
          <div class="app-header__mobile-menu-links">
            <a class="app-header__mobile-menu-link" v-for="item in rankingsLinks" :key="item.name"
              :href="`${channelPrefix}${item.path}`">
              <div class="app-header__mobile-menu-link-icon-container"
                v-if="getRankingIcon(item.name)">
                <img :src="getRankingIcon(item.name)" alt=""
                  class="app-header__mobile-menu-link-icon">
              </div>
              <div class="app-header__mobile-menu-link-text">{{ item.name }}</div>
            </a>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Resources Section -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-section-title">Resources</div>
          <div class="app-header__mobile-menu-links">
            <a class="app-header__mobile-menu-link" v-for="item in resourcesLinks" :key="item.name"
              :href="`${channelPrefix}${item.path}`">
              <div class="app-header__mobile-menu-link-icon-container"
                v-if="getResourceIcon(item.name)">
                <img :src="getResourceIcon(item.name)" alt=""
                  class="app-header__mobile-menu-link-icon">
              </div>
              <div class="app-header__mobile-menu-link-text">{{ item.name }}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig',
      categories: 'categories',
      categoriesLoaded: 'categoriesLoaded',
      headerTheme: 'headerTheme' // 从Vuex获取headerTheme
    }),
    homePath () {
      return this.channelPrefix || '/';
    },
    channelPrefix () {
      return this.$route.params.channel ? `/${this.$route.params.channel}` : '';
    },
    isFixedHeaderPage () {
      return ['categories', 'categoriesChannel', 'detail', 'rankings', 'about-us', 'privacy-policy', 'terms-of-service', 'disclaimer'].includes(this.$route.name);
    },
    finalHeaderTheme () {
      return this.isFixedHeaderPage ? 'dark' : this.headerTheme;
    },
    menuSrc () {
      return require('@/assets/mobile-menu.svg')
    }
  },
  data () {
    return {
      showMobileMenu: false,
      showCategoriesDropdown: false,
      showResourcesDropdown: false,
      isScrolled: false,
      navItems: [
        { name: 'Home', link: '/' },
        { name: 'Categories', link: '/all' },
        { name: 'Rankings', link: '/rank' },
        { name: 'Resources', link: '/resources' },
      ],
      rankingsLinks: [
        { name: 'Weekly Hot Books', path: '/rank?tab=weekly' },
        { name: 'Monthly Hot Books', path: '/rank?tab=monthly' },
        { name: 'Yearly Hot Books', path: '/rank?tab=yearly' },
      ],
      resourcesLinks: [
        { name: 'Terms of Services', path: '/terms-of-service' },
        { name: 'Privacy Policy', path: '/privacy-policy' },
        { name: 'Disclaimer', path: '/disclaimer' },
        { name: 'About Us', path: '/about-us' },
      ],
    };
  },
  methods: {
    getCategoryPath (category) {
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}/${category}`;
      }
      return `/${category}`;
    },
    handleScroll () {
      this.isScrolled = window.scrollY > 0;
    },
    toggleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu;

      // 如果打开菜单，禁止body滚动
      if (this.showMobileMenu) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    },

    toggleCategoriesDropdown () {
      this.showCategoriesDropdown = !this.showCategoriesDropdown;
    },

    // 判断当前路由是否激活
    isRouteActive (link) {
      // 获取不包含channel参数的当前路径
      let currentPath = this.$route.path;
      const channel = this.$route.params.channel;

      // 如果存在channel参数，移除channel部分以便正确比较
      if (channel && currentPath.startsWith(`/${channel}`)) {
        currentPath = currentPath.replace(`/${channel}`, '') || '/';
      }

      // 处理根路径特殊情况
      if (link === '/' && (currentPath === '/' || currentPath === '')) {
        return true;
      }

      // 处理首页特殊情况
      if (link === '/' && currentPath !== '/') {
        return false;
      }

      // Categories页面特殊处理
      if (link === '/categories') {
        // 如果路径是/categories或者是带有特定类别的路径（如/biography, /romance等）
        if (currentPath === '/categories') {
          return true;
        }

        // 检查是否是类别页面
        const categoryValues = this.categories.map(c => `/${c.value}`);
        if (categoryValues.includes(currentPath)) {
          return true;
        }

        return false;
      }

      // 其他页面直接比较路径
      return currentPath === link;
    },
    getRankingIcon (name) {
      try {
        if (/Weekly/i.test(name)) {
          return require('@/assets/menu/week.svg');
        }
        if (/Monthly/i.test(name)) {
          return require('@/assets/menu/month.svg');
        }
        if (/Yearly/i.test(name)) {
          return require('@/assets/menu/year.svg');
        }
        return require('@/assets/default/star-icon.svg');
      } catch (e) {
        return null;
      }
    },
    getResourceIcon (name) {
      try {
        if (/Home/i.test(name)) {
          return require('@/assets/arrow_outward.svg');
        }
        return null;
      } catch (e) {
        return null;
      }
    }
  },
  beforeDestroy () {
    // 确保在组件销毁时恢复body滚动
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    if (!this.isFixedHeaderPage) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  mounted () {
    // 监听路由变化，关闭移动菜单
    this.$router.afterEach(() => {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }

      // 关闭分类下拉菜单
      this.showCategoriesDropdown = false;
    });

    // 点击其他区域关闭下拉菜单
    document.addEventListener('click', (event) => {
      const dropdown = document.querySelector('.app-header__nav-item--has-dropdown');
      if (dropdown && !dropdown.contains(event.target) && this.showCategoriesDropdown) {
        this.showCategoriesDropdown = false;
      }
    });

    if (!this.isFixedHeaderPage) {
      window.addEventListener('scroll', this.handleScroll);
    } else {
      this.isScrolled = true;
    }
  }
};
</script>
